module.exports = __webpack_public_path__ + "assets/lessons/pl/lesson1/pages/lesson_1_5.pdf";